import { httpRequest } from '@/utils/umiRequest';

/** 获取全部国家和语种 */
export async function getCountryLanguages() {
  return await httpRequest.get('/country-languages');
}

/** 设置SAAS工单用户语种 */
export async function putSaasLanguages({ id, user_language }: { id: string; user_language: string }) {
  return await httpRequest.put(`/saas-dispute/${id}/language`, { user_language });
}

// /** 设置email工单用户语种 */
// export async function putEmailLanguages({ id, status, language_code }: { id: string; status: number; language_code: string }) {
//   return await httpRequest.put(`/email-ticket/${id}`, { language_code, status });
// }